// Dezenter Hinweis fuer iOS: "Zum Home-Bildschirm hinzufuegen" ueber das
// Teilen-Menue, da iOS anders als Android nie von selbst einen Install-
// Banner zeigt (Projektplan 10.2). Verschwindet nach dem Schliessen dauerhaft
// und sobald die Seite als eigenstaendige App laeuft.

import { useState } from "react";
import { X } from "lucide-react";
import { istEigenstaendig, istIOS } from "../lib/ios.js";

const SPEICHER_SCHLUESSEL = "kd-ios-hinweis-verborgen";

function warSchonVerborgen(): boolean {
  try {
    return localStorage.getItem(SPEICHER_SCHLUESSEL) === "1";
  } catch {
    // Privater Modus o. ae. kann den Zugriff verweigern - dann eben jedes
    // Mal zeigen, statt die Seite daran scheitern zu lassen.
    return false;
  }
}

export function IosInstallHinweis() {
  const [verborgen, setVerborgen] = useState(warSchonVerborgen);

  if (verborgen || istEigenstaendig() || !istIOS()) return null;

  function schliessen() {
    try {
      localStorage.setItem(SPEICHER_SCHLUESSEL, "1");
    } catch {
      // Kein Speicherzugriff: der Hinweis kommt beim naechsten Besuch
      // wieder, aber der Klick schliesst ihn wenigstens fuer jetzt.
    }
    setVerborgen(true);
  }

  return (
    <div className="flex items-center gap-2 bg-akzent px-3 py-2 text-xs text-white">
      <span className="flex-1">
        Zum Home-Bildschirm hinzufügen: unten das Teilen-Symbol antippen, dann „Zum
        Home-Bildschirm".
      </span>
      <button
        type="button"
        onClick={schliessen}
        aria-label="Hinweis schließen"
        className="flex min-h-8 min-w-8 shrink-0 items-center justify-center"
      >
        <X size={16} />
      </button>
    </div>
  );
}
